import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouses = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 75,
	height: 33,
	fill: "none",
	viewBox: "0 0 75 33",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#a9182f",
			d: "M16.44.86v2.08h-1.95V.86z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#822235",
			d: "M17.57.86v2.08H16.4V.86z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#522f18",
			d: "M16.22 26.34c.3-4.32 1.06-14.48.72-15.84L9.58 4.03l-6.65 7.25 2.5 15.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			fillOpacity: .35,
			d: "M8.36 13.62a.4.4 0 0 1 .3.12q.13.13.13.31 0 .19-.12.32a.4.4 0 0 1-.3.11l-.27-.01-4.7-.24-.27-.02-.1-.05-.05-.1q0-.08.04-.12l.11-.05.26-.01 4.71-.24zm4.14 3.51a.4.4 0 0 1-.3-.1.4.4 0 0 1-.12-.32q0-.19.12-.31a.4.4 0 0 1 .3-.11h.25l4.43.25.24.01q.06 0 .1.05t.05.11-.04.1l-.1.06-.25.01-4.43.24zm2.03-5.96a14 14 0 0 1-3.4.45 13 13 0 0 1-3.39-.45l.34-.09a13 13 0 0 1 6.45.09m-.23 8.82a31 31 0 0 1-5.2.45 30 30 0 0 1-5.18-.45 30 30 0 0 1 10.38 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "m31.92 25.9-15.7.44.72-15.12 16.36-1.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M18.16 10.77H16.3l-.64 15.57h1.44zM3.47 10.5l-1.02.95 2.32 15.18h1.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6d3f22",
			d: "M12.25 17.93H7.17l.61 8.49 4.47-.12z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M12.41 18.4q-.02-.22-.23-.24h-.36c-.12 0-.22.1-.22.22l-.14 8q.01.17.17.22l.32.1c.14.03.28-.07.28-.22zm-4.68-.07q-.02-.21-.23-.23h-.49q-.2.02-.22.23v7.52q0 .16.16.22l.39.13c.14.04.3-.06.3-.21z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M12.85 18.8c.14 0 .24-.14.22-.28l-.17-.91a.23.23 0 0 0-.22-.19H6.7c-.1 0-.2.08-.22.18l-.2.92c-.03.14.08.27.22.27z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M34.6 11.21c-.1.37-13.63.31-17.85.16l-7.2-6.14c-1.97 2.06-5.6 5.72-6.48 6.14s-1.2-.77-1.12-1.16l7.6-7.34h16.27c1.17.72 8.9 7.89 8.78 8.34"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: 4.89,
			x: 22.77,
			y: 15.11,
			fill: "#dcad54"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			x: 22.49,
			y: 14.94,
			fill: "#2e1a0b",
			rx: .42
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			x: 22.49,
			y: 19.61,
			fill: "#2e1a0b",
			rx: .42
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			x: 26.25,
			y: 20.23,
			fill: "#2e1a0b",
			transform: "rotate(-90 26.25 20.23)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			x: 22.66,
			y: 20,
			fill: "#2e1a0b",
			transform: "rotate(-90 22.66 20)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.92,
			height: .22,
			x: 23.33,
			y: 17.64,
			fill: "#6b5757"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: .22,
			x: 24.68,
			y: 19.61,
			fill: "#6b5757",
			transform: "rotate(-90 24.68 19.6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m25.48 14.87-.23.02c-.66.06-2.1.15-1.58.56.25.19.9-.11 1.14.14.41.43.73.22 1.04 0 .31-.24.47-.3.89-.06s.4-.23.18-.32c-.6-.24-.79-.4-1.44-.34m-1.55 5.03c-.96-.28-.06-.46.51-.52l1.29.17c1.36-.17.69.48.42.34-.34-.17-1.03.34-2.22 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			fillOpacity: .35,
			d: "M22.66 15.58a.4.4 0 0 1 .3.11q.12.13.12.32t-.12.31a.4.4 0 0 1-.3.12l-.27-.02-4.7-.24-.27-.01a.16.16 0 0 1-.15-.16q0-.06.05-.11l.1-.05.27-.02 4.7-.24zm4.14 3.51a.4.4 0 0 1-.3-.12.4.4 0 0 1-.13-.3q0-.2.12-.32a.4.4 0 0 1 .3-.11l.25.01 4.43.24.24.01q.06 0 .1.05t.05.11-.04.11l-.1.05-.25.01-4.43.24zm2.02-5.97a14 14 0 0 1-3.4.45 13 13 0 0 1-3.4-.45 14 14 0 0 1 3.4-.45 13 13 0 0 1 3.4.45m-.23 8.82a30 30 0 0 1-10.39 0 32 32 0 0 1 5.2-.45 30 30 0 0 1 5.19.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9f2fd",
			d: "m20.43 11.44 1.4.05c.72 0 5.1.18 7.93-.68 4.53-1.36.55-5.03-2.61-5.03-1.1 0-5.71 3.7-6.72 5.66"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a9182f",
			d: "M53.61 0v2.08h1.95V0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#822235",
			d: "M52.48 0v2.08h1.17V0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#522f18",
			d: "M53.82 25.48c-.29-4.32-1.06-14.48-.72-15.84l7.37-6.47 6.65 7.25-2.5 15.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			fillOpacity: .35,
			d: "M61.68 12.77a.4.4 0 0 0-.3.11.4.4 0 0 0-.13.32q0 .18.13.31a.4.4 0 0 0 .3.11h.27l4.7-.25.26-.01q.07 0 .11-.05l.05-.11-.05-.11-.1-.06h-.27l-4.7-.25zm-4.13 3.51q.17 0 .3-.12.12-.13.12-.3a.4.4 0 0 0-.12-.32.4.4 0 0 0-.3-.11h-.25l-4.43.25-.24.01-.11.05-.04.11q0 .06.04.1.05.06.1.06l.25.01 4.43.24zm-2.03-5.98.34.1a13 13 0 0 0 6.45-.1 14 14 0 0 0-3.4-.44 13 13 0 0 0-3.4.45m.24 8.82a30 30 0 0 0 10.38 0 31 31 0 0 0-5.19-.45 30 30 0 0 0-5.19.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "m38.13 25.05 15.7.43-.73-15.12-16.35-1.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M51.89 9.9h1.87l.64 15.58h-1.44zm14.69-.25 1.02.94-2.32 15.18h-1.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6d3f22",
			d: "M57.58 14.55h5.76v10.76h-5.76z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M56.82 15.46c0-.13.1-.24.24-.24h.65c.13 0 .24.1.24.23l.19 9.7q-.01.2-.19.24l-.59.15a.24.24 0 0 1-.3-.23zm6.05-.66c0-.12.1-.22.24-.22h.59c.14 0 .25.11.24.25l-.82 10.56a.24.24 0 0 1-.24.22h-.13a.24.24 0 0 1-.24-.25z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M56.78 15.47a.24.24 0 0 1-.24-.29l.2-1.08q.05-.19.24-.2h6.87q.18.01.24.19l.23 1.09a.24.24 0 0 1-.24.29z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M35.45 10.35c.1.37 13.63.31 17.85.16l7.2-6.06c1.97 2.06 5.6 5.64 6.48 6.06s1.2-.77 1.12-1.16l-7.6-7.33H44.23c-1.17.71-8.9 7.88-8.78 8.33"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9f2fd",
			d: "m35.11 10.66 1.4.05c.72 0 7.94.8 10.78-.05 1.49-.45-2.46-6.13-6.75-4.92-1.06.3-4.42 2.95-5.43 4.92"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: 4.89,
			fill: "#dcad54",
			transform: "matrix(-1 0 0 1 47.28 14.25)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			fill: "#2e1a0b",
			rx: .42,
			transform: "matrix(-1 0 0 1 47.56 14.08)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			fill: "#2e1a0b",
			rx: .42,
			transform: "matrix(-1 0 0 1 47.56 18.75)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			fill: "#2e1a0b",
			transform: "matrix(0 -1 -1 0 43.8 19.37)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			fill: "#2e1a0b",
			transform: "matrix(0 -1 -1 0 47.4 19.14)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.92,
			height: .22,
			fill: "#6b5757",
			transform: "matrix(-1 0 0 1 46.72 16.78)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: .22,
			fill: "#6b5757",
			transform: "matrix(0 -1 -1 0 45.37 18.75)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m44.57 14.01.23.02c.66.06 2.1.15 1.58.56-.25.19-.9-.11-1.14.14-.41.43-.73.23-1.04 0s-.47-.3-.89-.06-.4-.23-.18-.32c.6-.24.79-.4 1.44-.34m1.55 5.02c.96-.27.06-.45-.51-.5l-1.29.16c-1.36-.17-.69.48-.42.34.34-.17 1.03.35 2.22 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			fillOpacity: .35,
			d: "M47.4 14.72a.4.4 0 0 0-.3.11.4.4 0 0 0-.13.32q0 .19.12.31a.4.4 0 0 0 .3.12l.27-.02 4.7-.24.27-.01a.16.16 0 0 0 .15-.16l-.05-.11-.1-.05-.27-.02-4.7-.24zm-4.14 3.51a.4.4 0 0 0 .3-.11q.12-.13.12-.32a.4.4 0 0 0-.12-.3.4.4 0 0 0-.3-.12l-.25.01-4.43.24-.24.01-.1.05-.05.11q0 .06.04.11.05.05.1.05l.25.02 4.43.23zm-2.03-5.97a14 14 0 0 0 3.4.45 13 13 0 0 0 3.39-.45 14 14 0 0 0-3.4-.45 13 13 0 0 0-3.4.45m.24 8.82a31 31 0 0 0 5.2.45 30 30 0 0 0 5.18-.45 32 32 0 0 0-5.19-.45 30 30 0 0 0-5.19.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a9182f",
			d: "M36.36 5v2.07h1.95V5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#822235",
			d: "M35.22 5v2.07h1.17V5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#522f18",
			d: "M36.57 30.48c-.29-4.32-1.06-14.48-.72-15.84l7.36-6.48 6.65 7.26-2.5 15.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			fillOpacity: .35,
			d: "M49.2 18.15a.4.4 0 0 0 .3-.11q.12-.13.12-.32a.4.4 0 0 0-.13-.31.4.4 0 0 0-.3-.12l-.26.02-4.7.24-.27.01-.1.05-.05.11q0 .06.04.11.05.05.11.05l.26.02 4.71.24zm-8.9 3.12q.16.01.3-.1.11-.14.12-.32a.4.4 0 0 0-.13-.31.4.4 0 0 0-.3-.12l-.24.02-4.43.24h-.25l-.1.06-.05.1q0 .07.05.12.04.05.1.05l.25.01 4.43.24zm-2.04-5.97a14 14 0 0 0 3.4.45 13 13 0 0 0 3.4-.45 14 14 0 0 0-3.4-.45 13 13 0 0 0-3.4.45m.24 8.83a32 32 0 0 0 5.19.45 30 30 0 0 0 5.2-.45 30 30 0 0 0-10.4 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6d3f22",
			d: "m20.88 30.04 15.69.44-.72-15.12-16.36-1.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M34.63 14.9h1.87l.64 15.58H35.7zm14.69-.26 1.02.95-2.32 15.18h-1.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#373f2e",
			d: "M40.5 19.51h5.41v10.11H40.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M39.78 20.37c0-.13.1-.23.22-.23h.62c.12 0 .22.1.22.22l.18 9.12q0 .17-.18.22l-.55.14a.23.23 0 0 1-.28-.21zm5.69-.62q.02-.2.22-.22h.56q.21.02.22.25l-.76 9.92q-.02.2-.23.21h-.13a.23.23 0 0 1-.22-.23z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M39.74 20.37a.23.23 0 0 1-.22-.27l.2-1.02q.03-.16.21-.18h6.46q.18.01.22.17l.22 1.03a.23.23 0 0 1-.22.27z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M18.2 15.35c.1.36 13.63.3 17.85.16l7.2-5.94c1.97 2.05 5.59 5.52 6.47 5.94.89.41 1.21-.77 1.12-1.16l-7.6-7.34H26.99c-1.17.72-8.91 7.89-8.78 8.34"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: 4.89,
			fill: "#dcad54",
			transform: "matrix(-1 0 0 1 30.03 19.25)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			fill: "#2e1a0b",
			rx: .42,
			transform: "matrix(-1 0 0 1 30.3 19.08)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			fill: "#2e1a0b",
			rx: .42,
			transform: "matrix(-1 0 0 1 30.3 23.75)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			fill: "#2e1a0b",
			transform: "matrix(0 -1 -1 0 26.54 24.37)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			fill: "#2e1a0b",
			transform: "rotate(90 3 27.14)scale(-1 1)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.92,
			height: .22,
			fill: "#6b5757",
			transform: "matrix(-1 0 0 1 29.46 21.78)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: .22,
			fill: "#6b5757",
			transform: "matrix(0 -1 -1 0 28.11 23.75)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m27.31 19.01.23.02c.66.06 2.1.15 1.58.55-.25.2-.9-.1-1.14.15-.41.43-.73.22-1.04 0-.31-.24-.47-.3-.89-.06-.41.24-.4-.23-.18-.32.61-.24.79-.4 1.44-.34m1.55 5.02c.96-.27.06-.45-.5-.51l-1.3.17c-1.36-.17-.69.48-.42.34.35-.17 1.03.34 2.22 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			fillOpacity: .35,
			d: "M29.98 19.72a.4.4 0 0 0-.3.11.4.4 0 0 0-.12.31q0 .19.12.32a.4.4 0 0 0 .3.11l.27-.01 4.7-.24.27-.01q.06 0 .1-.06l.05-.1a.2.2 0 0 0-.05-.12l-.1-.05-.27-.01-4.7-.24zm-4.14 3.5a.4.4 0 0 0 .3-.1q.12-.14.13-.32a.4.4 0 0 0-.12-.31.4.4 0 0 0-.3-.12l-.25.02-4.43.24-.24.01-.11.05-.05.1q0 .07.05.12t.1.05l.25.01zm-2.03-5.96.34.08a13 13 0 0 0 6.46-.08 14 14 0 0 0-3.4-.46 13 13 0 0 0-3.4.46m.24 8.82a30 30 0 0 0 10.38 0 32 32 0 0 0-5.19-.45 30 30 0 0 0-5.2.45"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: 4.89,
			fill: "#dcad54",
			transform: "matrix(-1 0 0 1 11.8 9.73)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			fill: "#2e1a0b",
			rx: .42,
			transform: "matrix(-1 0 0 1 12.09 9.56)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .84,
			fill: "#2e1a0b",
			rx: .42,
			transform: "matrix(-1 0 0 1 12.09 14.23)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			fill: "#2e1a0b",
			transform: "matrix(0 -1 -1 0 8.32 14.85)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.67,
			height: .67,
			fill: "#2e1a0b",
			transform: "matrix(0 -1 -1 0 11.92 14.62)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.92,
			height: .22,
			fill: "#6b5757",
			transform: "matrix(-1 0 0 1 11.24 12.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.82,
			height: .22,
			fill: "#6b5757",
			transform: "matrix(0 -1 -1 0 9.9 14.23)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M10.64 14.52c.96-.28.06-.46-.5-.52l-1.3.17c-1.36-.17-.69.48-.42.35.35-.18 1.03.34 2.22 0m45.81 17.94c0 1.22-6.37 0-10.88 0-4.5 0-7.9-.42-7.9-1.63 1.83-.85 3.4-2.77 7.9-2.77s10.88 3.18 10.88 4.4m-41.87-4.19c0 1.26-4.54 0-7.75 0-3.22 0-5.64-.44-5.64-1.7 1.31-.88 2.42-2.89 5.64-2.89 3.2 0 7.75 3.32 7.75 4.59M29 30.33c0 1.26-4.55 0-7.76 0s-5.63-.44-5.63-1.7c1.3-.89 2.42-2.89 5.63-2.89S29 29.06 29 30.33m45.47-3.21c0 .98-5.7 0-9.74 0s-7.07-.33-7.07-1.3c1.65-.68 3.04-2.22 7.07-2.22s9.74 2.55 9.74 3.52"
		})
	]
});
export default SvgHouses;
